/**
 * Generated from ch6_p07.fla
 */
export function ch6_p07(this: Ich6_p07) {
	const horse = this.horse;
	if (!horse[0] && horse.elementFactory) {
		horse[0] = horse.elementFactory(0,undefined);
	}
	if (horse[0]) {
		ch6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p07_horse.call(horse[0] as Ich6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p07_horse);
		horse[0].x = 657.75;
		horse[0].y = 768;
		horse[0].width = 607.50;
		horse[0].height = 675.50;
		horse[0].alpha = 1;
		if (horse[0].onLayout) horse[0].onLayout();
	}
	if (!horse[1] && horse.elementFactory) {
		horse[1] = horse.elementFactory(1,undefined);
	}
	if (horse[1]) {
		ch6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p08_horse.call(horse[1] as Ich6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p08_horse);
		horse[1].x = 657.75;
		horse[1].y = 768;
		horse[1].width = 607.50;
		horse[1].height = 675.50;
		horse[1].alpha = 1;
		if (horse[1].onLayout) horse[1].onLayout();
	}
	if (!horse[2] && horse.elementFactory) {
		horse[2] = horse.elementFactory(2,undefined);
	}
	if (horse[2]) {
		ch6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p09_horse.call(horse[2] as Ich6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p09_horse);
		horse[2].x = 657.75;
		horse[2].y = 768;
		horse[2].width = 607.50;
		horse[2].height = 675.50;
		horse[2].alpha = 1;
		if (horse[2].onLayout) horse[2].onLayout();
	}
	if (!horse[3] && horse.elementFactory) {
		horse[3] = horse.elementFactory(3,undefined);
	}
	if (horse[3]) {
		ch6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p09b_horse.call(horse[3] as Ich6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p09b_horse);
		horse[3].x = 657.75;
		horse[3].y = 768;
		horse[3].width = 607.50;
		horse[3].height = 675.50;
		horse[3].alpha = 1;
		if (horse[3].onLayout) horse[3].onLayout();
	}
	const tyler = this.tyler;
	if (!tyler[0] && tyler.elementFactory) {
		tyler[0] = tyler.elementFactory(0,undefined);
	}
	if (tyler[0]) {
		ch6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p07_tyler.call(tyler[0] as Ich6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p07_tyler);
		tyler[0].x = 1128.5;
		tyler[0].y = 768;
		tyler[0].width = 355.00;
		tyler[0].height = 607.00;
		tyler[0].alpha = 1;
		if (tyler[0].onLayout) tyler[0].onLayout();
	}
	if (!tyler[1] && tyler.elementFactory) {
		tyler[1] = tyler.elementFactory(1,undefined);
	}
	if (tyler[1]) {
		ch6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p08_tyler.call(tyler[1] as Ich6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p08_tyler);
		tyler[1].x = 1132.75;
		tyler[1].y = 768;
		tyler[1].width = 352.50;
		tyler[1].height = 581.00;
		tyler[1].alpha = 1;
		if (tyler[1].onLayout) tyler[1].onLayout();
	}
	if (!tyler[2] && tyler.elementFactory) {
		tyler[2] = tyler.elementFactory(2,undefined);
	}
	if (tyler[2]) {
		ch6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p09_tyler.call(tyler[2] as Ich6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p09_tyler);
		tyler[2].x = 1123.75;
		tyler[2].y = 768;
		tyler[2].width = 358.50;
		tyler[2].height = 585.50;
		tyler[2].alpha = 1;
		if (tyler[2].onLayout) tyler[2].onLayout();
	}
	if (!tyler[3] && tyler.elementFactory) {
		tyler[3] = tyler.elementFactory(3,undefined);
	}
	if (tyler[3]) {
		ch6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p09b_tyler.call(tyler[3] as Ich6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p09b_tyler);
		tyler[3].x = 1151;
		tyler[3].y = 768;
		tyler[3].width = 312.00;
		tyler[3].height = 606.00;
		tyler[3].alpha = 1;
		if (tyler[3].onLayout) tyler[3].onLayout();
	}
	const holly = this.holly;
	if (!holly[0] && holly.elementFactory) {
		holly[0] = holly.elementFactory(0,undefined);
	}
	if (holly[0]) {
		ch6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p07_holly.call(holly[0] as Ich6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p07_holly);
		holly[0].x = 889.75;
		holly[0].y = 768;
		holly[0].width = 227.50;
		holly[0].height = 559.50;
		holly[0].alpha = 1;
		if (holly[0].onLayout) holly[0].onLayout();
	}
	if (!holly[1] && holly.elementFactory) {
		holly[1] = holly.elementFactory(1,undefined);
	}
	if (holly[1]) {
		ch6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p08_holly.call(holly[1] as Ich6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p08_holly);
		holly[1].x = 889.75;
		holly[1].y = 768;
		holly[1].width = 227.50;
		holly[1].height = 559.50;
		holly[1].alpha = 1;
		if (holly[1].onLayout) holly[1].onLayout();
	}
	if (!holly[2] && holly.elementFactory) {
		holly[2] = holly.elementFactory(2,undefined);
	}
	if (holly[2]) {
		ch6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p09_holly.call(holly[2] as Ich6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p09_holly);
		holly[2].x = 889.75;
		holly[2].y = 768;
		holly[2].width = 227.50;
		holly[2].height = 560.00;
		holly[2].alpha = 1;
		if (holly[2].onLayout) holly[2].onLayout();
	}
	if (!holly[3] && holly.elementFactory) {
		holly[3] = holly.elementFactory(3,undefined);
	}
	if (holly[3]) {
		ch6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p09b_holly.call(holly[3] as Ich6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p09b_holly);
		holly[3].x = 897.5;
		holly[3].y = 768;
		holly[3].width = 242.00;
		holly[3].height = 560.50;
		holly[3].alpha = 1;
		if (holly[3].onLayout) holly[3].onLayout();
	}
	const tylerFront = this.tylerFront;
	if (!tylerFront[0] && tylerFront.elementFactory) {
		tylerFront[0] = tylerFront.elementFactory(0,undefined);
	}
	if (tylerFront[0]) {
		ch6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p07_tylerfront.call(tylerFront[0] as Ich6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p07_tylerfront);
		tylerFront[0].x = 1102.75;
		tylerFront[0].y = 545;
		tylerFront[0].width = 305.50;
		tylerFront[0].height = 216.00;
		tylerFront[0].alpha = 1;
		if (tylerFront[0].onLayout) tylerFront[0].onLayout();
	}
	if (!tylerFront[1] && tylerFront.elementFactory) {
		tylerFront[1] = tylerFront.elementFactory(1,undefined);
	}
	if (tylerFront[1]) {
		ch6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p08_tylerfront.call(tylerFront[1] as Ich6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p08_tylerfront);
		tylerFront[1].x = 1089.5;
		tylerFront[1].y = 564;
		tylerFront[1].width = 294.00;
		tylerFront[1].height = 231.00;
		tylerFront[1].alpha = 1;
		if (tylerFront[1].onLayout) tylerFront[1].onLayout();
	}
	if (!tylerFront[2] && tylerFront.elementFactory) {
		tylerFront[2] = tylerFront.elementFactory(2,undefined);
	}
	if (tylerFront[2]) {
		ch6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p09_tylerfront.call(tylerFront[2] as Ich6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p09_tylerfront);
		tylerFront[2].x = 1085.25;
		tylerFront[2].y = 548;
		tylerFront[2].width = 278.50;
		tylerFront[2].height = 217.00;
		tylerFront[2].alpha = 1;
		if (tylerFront[2].onLayout) tylerFront[2].onLayout();
	}
	if (!tylerFront[3] && tylerFront.elementFactory) {
		tylerFront[3] = tylerFront.elementFactory(3,undefined);
	}
	if (tylerFront[3]) {
		ch6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p09b_tylerfront.call(tylerFront[3] as Ich6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p09b_tylerfront);
		tylerFront[3].x = 1251.5;
		tylerFront[3].y = 757;
		tylerFront[3].width = 87.00;
		tylerFront[3].height = 424.50;
		tylerFront[3].alpha = 1;
		if (tylerFront[3].onLayout) tylerFront[3].onLayout();
	}
	const rain = this.rain;
	if (!rain[0] && rain.elementFactory) {
		rain[0] = rain.elementFactory(0,undefined);
	}
	if (rain[0]) {
		ch6_p07_hh_ch6_72dpi_p070809psdAssetrainoverlayrain2.call(rain[0] as Ich6_p07_hh_ch6_72dpi_p070809psdAssetrainoverlayrain2);
		rain[0].x = 820.5;
		rain[0].y = 384;
		rain[0].width = 1641.00;
		rain[0].height = 768.00;
		rain[0].alpha = 1;
		if (rain[0].onLayout) rain[0].onLayout();
	}
	if (!rain[1] && rain.elementFactory) {
		rain[1] = rain.elementFactory(1,undefined);
	}
	if (rain[1]) {
		ch6_p07_hh_ch6_72dpi_p070809psdAssetrainoverlayrain1.call(rain[1] as Ich6_p07_hh_ch6_72dpi_p070809psdAssetrainoverlayrain1);
		rain[1].x = 813.75;
		rain[1].y = 388.5;
		rain[1].width = 1600.50;
		rain[1].height = 759.00;
		rain[1].alpha = 1;
		if (rain[1].onLayout) rain[1].onLayout();
	}
	const bg = this.bg;
	ch6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p07_bg.call(this.bg);
	bg.x = 832;
	bg.y = 384;
	bg.width = 1664.00;
	bg.height = 768.00;
	bg.alpha = 1.00;
	if (bg.onLayout) bg.onLayout();
	const frameRight = this.frameRight;
	ch6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p07_wcframeRframe.call(this.frameRight);
	frameRight.x = 1664;
	frameRight.y = 384;
	frameRight.width = 354.00;
	frameRight.height = 768.00;
	frameRight.alpha = 1.00;
	if (frameRight.onLayout) frameRight.onLayout();
	const linesRight = this.linesRight;
	ch6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p07_wcframerline.call(this.linesRight);
	linesRight.x = 1663;
	linesRight.y = 589;
	linesRight.width = 92.50;
	linesRight.height = 322.00;
	linesRight.alpha = 1.00;
	if (linesRight.onLayout) linesRight.onLayout();
	const frameLeft = this.frameLeft;
	ch6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p07_wcframeLframe.call(this.frameLeft);
	frameLeft.x = 0;
	frameLeft.y = 384;
	frameLeft.width = 342.50;
	frameLeft.height = 768.00;
	frameLeft.alpha = 1.00;
	if (frameLeft.onLayout) frameLeft.onLayout();
	const linesLeft = this.linesLeft;
	ch6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p07_wcframelline.call(this.linesLeft);
	linesLeft.x = 0;
	linesLeft.y = 659.5;
	linesLeft.width = 93.00;
	linesLeft.height = 212.00;
	linesLeft.alpha = 1.00;
	if (linesLeft.onLayout) linesLeft.onLayout();
	return this;
}
function ch6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p07_bg(this: Ich6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p07_bg) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp6_p07_bg", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p07_horse(this: Ich6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p07_horse) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp6_p07_horse", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p07_tyler(this: Ich6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p07_tyler) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp6_p07_tyler", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p07_holly(this: Ich6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p07_holly) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp6_p07_holly", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p07_tylerfront(this: Ich6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p07_tylerfront) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp6_p07_tylerfront", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p08_horse(this: Ich6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p08_horse) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp6_p08_horse", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p08_tyler(this: Ich6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p08_tyler) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp6_p08_tyler", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p08_holly(this: Ich6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p08_holly) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp6_p08_holly", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p08_tylerfront(this: Ich6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p08_tylerfront) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp6_p08_tylerfront", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p09_horse(this: Ich6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p09_horse) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp6_p09_horse", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p09_tyler(this: Ich6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p09_tyler) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp6_p09_tyler", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p09_holly(this: Ich6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p09_holly) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp6_p09_holly", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p09_tylerfront(this: Ich6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p09_tylerfront) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp6_p09_tylerfront", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p09b_horse(this: Ich6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p09b_horse) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp6_p09b_horse", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p09b_tyler(this: Ich6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p09b_tyler) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp6_p09b_tyler", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p09b_holly(this: Ich6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p09b_holly) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp6_p09b_holly", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p09b_tylerfront(this: Ich6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p09b_tylerfront) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp6_p09b_tylerfront", 0.500, 1.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p07_hh_ch6_72dpi_p070809psdAssetrainoverlayrain2(this: Ich6_p07_hh_ch6_72dpi_p070809psdAssetrainoverlayrain2) {
	if (this.setLayoutTexture) this.setLayoutTexture("rain2", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("overlay");
	return this;
}
function ch6_p07_hh_ch6_72dpi_p070809psdAssetrainoverlayrain1(this: Ich6_p07_hh_ch6_72dpi_p070809psdAssetrainoverlayrain1) {
	if (this.setLayoutTexture) this.setLayoutTexture("rain1", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p07_wcframeRframe(this: Ich6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p07_wcframeRframe) {
	if (this.setLayoutTexture) this.setLayoutTexture("Rframe", 1.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p07_wcframerline(this: Ich6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p07_wcframerline) {
	if (this.setLayoutTexture) this.setLayoutTexture("rline", 1.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("multiply");
	return this;
}
function ch6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p07_wcframeLframe(this: Ich6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p07_wcframeLframe) {
	if (this.setLayoutTexture) this.setLayoutTexture("Lframe", 0.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p07_wcframelline(this: Ich6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p07_wcframelline) {
	if (this.setLayoutTexture) this.setLayoutTexture("lline", 0.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
interface Ich6_p07Array<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface Ich6_p07Container {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface Ich6_p07Sprite extends Ich6_p07Container {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
	alpha: number;
	setBlendMode?(blendMode: string): void;
}
interface Ich6_p07Text extends Ich6_p07Container {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface Ich6_p07Polygon extends Array<number> {
}
interface Ich6_p07 {
	readonly horse: Ich6_p07Array<Ich6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p07_horse|Ich6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p08_horse|Ich6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p09_horse|Ich6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p09b_horse>;
	readonly tyler: Ich6_p07Array<Ich6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p07_tyler|Ich6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p08_tyler|Ich6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p09_tyler|Ich6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p09b_tyler>;
	readonly holly: Ich6_p07Array<Ich6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p07_holly|Ich6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p08_holly|Ich6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p09_holly|Ich6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p09b_holly>;
	readonly tylerFront: Ich6_p07Array<Ich6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p07_tylerfront|Ich6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p08_tylerfront|Ich6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p09_tylerfront|Ich6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p09b_tylerfront>;
	readonly rain: Ich6_p07Array<Ich6_p07_hh_ch6_72dpi_p070809psdAssetrainoverlayrain2|Ich6_p07_hh_ch6_72dpi_p070809psdAssetrainoverlayrain1>;
	readonly bg: Ich6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p07_bg;
	readonly frameRight: Ich6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p07_wcframeRframe;
	readonly linesRight: Ich6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p07_wcframerline;
	readonly frameLeft: Ich6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p07_wcframeLframe;
	readonly linesLeft: Ich6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p07_wcframelline;
}
interface Ich6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p07_bg extends Ich6_p07Sprite {
}
interface Ich6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p07_horse extends Ich6_p07Sprite {
}
interface Ich6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p07_tyler extends Ich6_p07Sprite {
}
interface Ich6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p07_holly extends Ich6_p07Sprite {
}
interface Ich6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p07_tylerfront extends Ich6_p07Sprite {
}
interface Ich6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p08_horse extends Ich6_p07Sprite {
}
interface Ich6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p08_tyler extends Ich6_p07Sprite {
}
interface Ich6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p08_holly extends Ich6_p07Sprite {
}
interface Ich6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p08_tylerfront extends Ich6_p07Sprite {
}
interface Ich6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p09_horse extends Ich6_p07Sprite {
}
interface Ich6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p09_tyler extends Ich6_p07Sprite {
}
interface Ich6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p09_holly extends Ich6_p07Sprite {
}
interface Ich6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p09_tylerfront extends Ich6_p07Sprite {
}
interface Ich6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p09b_horse extends Ich6_p07Sprite {
}
interface Ich6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p09b_tyler extends Ich6_p07Sprite {
}
interface Ich6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p09b_holly extends Ich6_p07Sprite {
}
interface Ich6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p09b_tylerfront extends Ich6_p07Sprite {
}
interface Ich6_p07_hh_ch6_72dpi_p070809psdAssetrainoverlayrain2 extends Ich6_p07Sprite {
}
interface Ich6_p07_hh_ch6_72dpi_p070809psdAssetrainoverlayrain1 extends Ich6_p07Sprite {
}
interface Ich6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p07_wcframeRframe extends Ich6_p07Sprite {
}
interface Ich6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p07_wcframerline extends Ich6_p07Sprite {
}
interface Ich6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p07_wcframeLframe extends Ich6_p07Sprite {
}
interface Ich6_p07_hh_ch6_72dpi_p070809psdAssetchp6_p07_wcframelline extends Ich6_p07Sprite {
}
